<div
    #editorContainer
    [ngStyle]="{ height: getHeightOptions().value, width: getWidthOptions().value }"
    class="editorContainer"></div>
